import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b376ab0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "df"
};
const _hoisted_2 = {
  class: "df-table"
};
const _hoisted_3 = {
  class: "sticky standard"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th"), /*#__PURE__*/_createElementVNode("th")], -1));
const _hoisted_5 = {
  class: "standard",
  style: {
    "background-color": "#f7f7f7"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Product name", -1));
const _hoisted_7 = {
  class: "standard",
  width: "143",
  style: {
    "background-color": "#f8fffe"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "product-package-style"
}, "Product Package")], -1));
const _hoisted_9 = {
  class: "sub-cells"
};
const _hoisted_10 = {
  class: "sub-cell"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "sub-cell"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "sub-cell"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "sub-cell",
  style: {
    "background-color": "#f2fffd"
  }
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "62px",
  style: {
    "background-color": "#f5f7fa"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title dark",
  style: {
    "font-size": "14px"
  }
}, "Units per box")])], -1));
const _hoisted_19 = {
  class: "standard",
  width: "143",
  style: {
    "background-color": "#fafdff"
  }
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "product-package-style"
}, "Box")], -1));
const _hoisted_21 = {
  class: "sub-cells"
};
const _hoisted_22 = {
  class: "sub-cell"
};
const _hoisted_23 = {
  class: "title"
};
const _hoisted_24 = {
  class: "sub-cell"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  class: "sub-cell"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "sub-cell",
  style: {
    "background-color": "#f5fbff"
  }
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "95px"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {
    "text-align": "left"
  }
}, " Expiration date required ")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_product_data_content_row = _resolveComponent("product-data-content-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("table", _hoisted_2, [_createElementVNode("thead", _hoisted_3, [_hoisted_4, _createElementVNode("tr", null, [_createElementVNode("th", _hoisted_5, [_createElementVNode("div", {
    class: "th sortable",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.onSort('product_name'), ["stop"]))
  }, [_hoisted_6, _createVNode(_component_app_icon, {
    icon: `chevron-down2`,
    color: $props.sortField == 'product_name' ? '#5A52AE' : '#757575',
    style: _normalizeStyle(`transform: rotate(${$props.sortDirection == 'asc' ? 0 : 180}deg)`)
  }, null, 8, ["color", "style"])])]), _createElementVNode("th", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, "length(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, "height(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, "width(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, "weight(" + _toDisplayString($options.weightUnit) + ")", 1)])])]), _hoisted_18, _createElementVNode("th", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, "length(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, "height(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, "width(" + _toDisplayString($options.lengthUnit) + ")", 1)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, "weight(" + _toDisplayString($options.weightUnit) + ")", 1)])])]), _hoisted_30])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item, index) => {
    return _openBlock(), _createBlock(_component_product_data_content_row, {
      key: `${item.asin}-${index}`,
      item: item,
      selected: $props.selected.includes(item.asin),
      scaleType: $props.scaleType,
      defaultScaleType: $props.defaultScaleType,
      onSelect: $options.onSelect,
      onUpdate: $options.onUpdate,
      onExpiration: $options.onExpirationDateRequired
    }, null, 8, ["item", "selected", "scaleType", "defaultScaleType", "onSelect", "onUpdate", "onExpiration"]);
  }), 128))])])]);
}